import { render, staticRenderFns } from "./HomeYjj.vue?vue&type=template&id=cc068fce&scoped=true&"
import script from "./HomeYjj.vue?vue&type=script&lang=js&"
export * from "./HomeYjj.vue?vue&type=script&lang=js&"
import style0 from "./HomeYjj.vue?vue&type=style&index=0&id=cc068fce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc068fce",
  null
  
)

export default component.exports